import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-center bg-300 mb-5 p-1 rounded" }
const _hoisted_2 = { class: "text-center text-primary display-2 mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Newsletter", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_row = _resolveComponent("b-form-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('welcome', {name: `${_ctx.storedUser.firstname} ${_ctx.storedUser.lastname}`})), 1),
    _createVNode(_component_b_row, { class: "justify-content-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          md: "5",
          lg: "4",
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                icon: [_ctx.$store.state.family, 'user-circle']
              }, null, 8, ["icon"])
            ]),
            _createVNode(_component_b_form, {
              onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, { sm: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_form_group, {
                          label: _ctx.$t('form.firstname')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_input, {
                              modelValue: _ctx.user.firstname,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstname) = $event)),
                              placeholder: _ctx.$t('form.firstname')
                            }, null, 8, ["modelValue", "placeholder"])
                          ], undefined, true),
                          _: 1
                        }, 8, ["label"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, { sm: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_form_group, {
                          label: _ctx.$t('form.lastname')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_input, {
                              modelValue: _ctx.user.lastname,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastname) = $event)),
                              placeholder: _ctx.$t('form.lastname')
                            }, null, 8, ["modelValue", "placeholder"])
                          ], undefined, true),
                          _: 1
                        }, 8, ["label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_b_form_group, {
                  label: _ctx.$t('form.email')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      modelValue: _ctx.user.login,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.login) = $event)),
                      placeholder: _ctx.$t('form.email'),
                      disabled: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ], undefined, true),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_b_list_group, { class: "mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_list_group_item, { class: "d-flex align-items-center justify-content-between p-2" }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_b_form_checkbox, {
                          modelValue: _ctx.user.newsletter,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.newsletter) = $event)),
                          switch: ""
                        }, null, 8, ["modelValue"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                (_ctx.showPassword)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_4,
                      _createVNode(_component_b_form_group, {
                        label: _ctx.$t('form.oldPassword')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_input, {
                            type: "password",
                            modelValue: _ctx.user.oldPassword,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.oldPassword) = $event)),
                            placeholder: _ctx.$t('form.password')
                          }, null, 8, ["modelValue", "placeholder"])
                        ], undefined, true),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_b_form_group, {
                        label: _ctx.$t('form.newPassword')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_input, {
                            type: "password",
                            modelValue: _ctx.user.newPassword1,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.newPassword1) = $event)),
                            placeholder: _ctx.$t('form.password')
                          }, null, 8, ["modelValue", "placeholder"])
                        ], undefined, true),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_b_form_group, {
                        label: _ctx.$t('form.newPassword')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_input, {
                            type: "password",
                            modelValue: _ctx.user.newPassword2,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.newPassword2) = $event)),
                            placeholder: _ctx.$t('form.password')
                          }, null, 8, ["modelValue", "placeholder"]),
                          (_ctx.user.newPassword1 != _ctx.user.newPassword2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('form.badPassword')), 1))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      }, 8, ["label"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_b_link, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPassword = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('form.update')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ])),
                _createVNode(_component_b_button, {
                  variant: "primary",
                  type: "submit",
                  block: "",
                  disabled: !_ctx.isValid && _ctx.showPassword == true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: [_ctx.$store.state.family, 'save']
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('form.save')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"])
              ], undefined, true),
              _: 1
            }, 8, ["onSubmit"])
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ]))
}